import { render, staticRenderFns } from "./BnplPrescores.vue?vue&type=template&id=52af2083&scoped=true&"
import script from "./BnplPrescores.vue?vue&type=script&lang=js&"
export * from "./BnplPrescores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af2083",
  null
  
)

export default component.exports